import { Directive, Input, OnChanges } from '@angular/core';
import {
  NzFilterOptionType,
  NzSelectComponent,
  NzSelectItemInterface,
} from 'ng-zorro-antd/select';

export interface TerminologySearchOption {
  id?: unknown;
  value?: unknown;
  code?: unknown;
  name?: unknown;
  englishName?: unknown;
  display?: unknown;
  label?: unknown;
}

@Directive({
  selector: 'nz-select[appTerminologySearch]',
  standalone: true,
})
export class TerminologySearchDirective implements OnChanges {
  @Input() appTerminologySearch: readonly TerminologySearchOption[] | null | undefined;

  private optionsByValue = new Map<string, TerminologySearchOption[]>();

  readonly filterOption: NzFilterOptionType = (input, option) =>
    this.matches(input, option);

  constructor(select: NzSelectComponent) {
    select.nzFilterOption = this.filterOption;
  }

  ngOnChanges(): void {
    this.optionsByValue = new Map();
    for (const option of this.appTerminologySearch ?? []) {
      const value = this.valueKey(option.id ?? option.value);
      const matches = this.optionsByValue.get(value) ?? [];
      matches.push(option);
      this.optionsByValue.set(value, matches);
    }
  }

  private matches(input: string, renderedOption: NzSelectItemInterface): boolean {
    const query = input.trim().toLocaleLowerCase();
    if (!query) return true;

    const options = this.optionsByValue.get(this.valueKey(renderedOption.nzValue)) ?? [];
    if (options.some((option) => this.optionMatches(option, query))) return true;

    return String(renderedOption.nzLabel ?? '').toLocaleLowerCase().includes(query);
  }

  private optionMatches(option: TerminologySearchOption, query: string): boolean {
    return [option.code, option.name, option.englishName, option.display, option.label]
      .some((value) => value != null && String(value).trim().toLocaleLowerCase().includes(query));
  }

  private valueKey(value: unknown): string {
    return String(value ?? '');
  }
}
